import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PropTypes from 'prop-types';
import s from './ThemeScreenshotSlider.css';
import useStyles from "isomorphic-style-loader/useStyles";
import Slider from "../../components/Common/Slider/Slider";

const properties = {
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: true,
    arrows: true,
    onChange: (oldIndex, newIndex) => {
        //console.log(`slide transition from ${oldIndex} to ${newIndex}`);
    }
};

function ThemeScreenshotSlider({ slug, workspaces, defaultIndex }) {
    function renderSlides() {
        useStyles(s);

        if (workspaces.indexOf(defaultIndex + '') === -1) {
            workspaces.push(defaultIndex);
        }

        return workspaces.map((workspace) => {
            return (
                <div style={{'backgroundImage': `url(/screenshots/1200/${slug}-${workspace}.jpg)`}} key={`theme-slide${workspace}`} />
            );
        });
    }

    return (
        <div className={s.slideContainer}>
            <Slider defaultIndex={defaultIndex}>
                {renderSlides()}
            </Slider>
        </div>
    );
}

export default ThemeScreenshotSlider;

ThemeScreenshotSlider.propTypes = {
    slug: PropTypes.string.isRequired,
    workspaces: PropTypes.array.isRequired
};
